'use strict'
import moment from 'moment-timezone'
const { localeFormats } = require('../constants/index')

// https://en.wikipedia.org/wiki/Date_format_by_country
export function isUSAMonthDayOrder(locale) {
  // means day last
  if (locale === 'en_US') {
    return true
  } else {
    return false
  }
}

export function formatRange(start, end, currentYear, dateMoment, locale) {
  let ret

  if (start.isSame(end, 'month')) {
    let isMonthBeforeDay = isUSAMonthDayOrder(locale)
    if (isMonthBeforeDay) {
      ret = start.formatLocalized('MMMM D') + ' - ' + (currentYear === dateMoment.format('YYYY') ? end.formatLocalized('D') : end.formatLocalized('D, YYYY'))
    } else {
      ret =
        start.formatLocalized('D') + ' - ' + (currentYear === dateMoment.format('YYYY') ? end.formatLocalized('D MMMM') : end.formatLocalized('D MMMM, YYYY'))
    }
  } else {
    if (start.format('YYYY') !== currentYear && end.format('YYYY') !== currentYear) {
      ret = start.formatLocalized('MMM D') + ' - ' + end.formatLocalized('MMM D, YYYY')
    } else if (start.isSame(end, 'year')) {
      ret = start.formatLocalized('MMM D') + ' - ' + end.formatLocalized('MMM D')
    } else {
      ret = start.formatLocalized('MMM D, YYYY') + ' - ' + end.formatLocalized('MMM D, YYYY')
    }
  }
  return ret
}

export function getLocaleFormat(format, locale) {
  let f = localeFormats[locale]
  if (f) {
    let locFormat = f[format]
    if (locFormat) {
      return locFormat
    }
  }
  return format
}

export function timeBetweenDates(dateA, dateB) {
  if (dateA == null || dateB == null) return null

  if (typeof dateA.getTime !== 'function' || typeof dateB.getTime !== 'function') return null

  return dateB.getTime() - dateA.getTime()
}

/**
 * Returns absolute difference between two dates in minutes
 * @param {Date} dateA
 * @param {Date} dateB
 * @return {number} Diff in minutes
 */
export function absoluteDateDiffInMinutes(dateA, dateB) {
  const diff = Math.abs(timeBetweenDates(dateA, dateB))
  return diff / 1000 / 60
}

export function millisToDurationString(time) {
  if (time == null || time < 0) return null

  const seconds = time / 1000
  const minutes = Math.floor(seconds / 60) % 60
  const hours = Math.floor(seconds / 60 / 60)

  return hours + ':' + (minutes < 10 ? '0' : '') + minutes
}

export function longerHourDurationFormatted(start_date, end_date) {
  let momentDuration = moment.duration(moment(end_date).diff(moment(start_date)))

  let stringTime =
    Math.floor(momentDuration.asHours()) +
    ':' +
    ((Math.floor(momentDuration.asMinutes()) % 60).toString().length === 1 ? '0' : '') +
    (Math.floor(momentDuration.asMinutes()) % 60)
  return {
    time: stringTime,
    hours: Math.floor(momentDuration.asHours()),
    minutes: Math.floor(momentDuration.asMinutes()) % 60,
  }
}

export function durationFormatted(startDate, endDate, parentWidth, type = null) {
  let start = moment(startDate)
  let end = moment(endDate)
  let diff = moment.duration(end.diff(start))

  let hours = diff.asHours()
  if (hours >= 24 || (type !== null && type !== 'work')) {
    let days = Math.round(hours / 24)
    return days + 'd'
  } else {
    let minutes = ((Math.floor(diff.asMinutes()) % 60).toString().length === 1 ? '0' : '') + (Math.floor(diff.asMinutes()) % 60)
    if (minutes !== '00') return Math.floor(hours) + ':' + minutes + (parentWidth > 60 ? 'h' : '')
    else return Math.floor(hours) + 'h'
  }
}

function dayIndex(dayName) {
  if (dayName === undefined) return 0
  const days = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  }
  return days[dayName]
}

export function getThisWeekStart(startWeekDay, timezone) {
  let startOfWeekInd = dayIndex(startWeekDay)
  moment.locale('kr', {
    week: {
      dow: startOfWeekInd,
      doy: 6,
    },
  })

  var nextWeekStart = moment().locale('kr').tz(timezone).startOf('week')

  moment.locale('en')

  return nextWeekStart
}

export function getNextWeekStartFromDate(date, startWeekDay, timezone) {
  let startOfWeekInd = dayIndex(startWeekDay)
  moment.locale('kr', {
    week: {
      dow: startOfWeekInd,
      doy: 6,
    },
  })

  var nextWeekStart = moment(date).locale('kr').tz(timezone).startOf('week').add(1, 'week')

  moment.locale('en')

  return nextWeekStart
}

export function getWeekStartFromDate(date, startWeekDay, timezone) {
  let startOfWeekInd = dayIndex(startWeekDay)
  moment.locale('kr', {
    week: {
      dow: startOfWeekInd,
      doy: 6,
    },
  })

  var nextWeekStart = moment(date).locale('kr').tz(timezone).startOf('week')

  moment.locale('en')

  return nextWeekStart
}

export function getNextWeekStartDate(startWeekDay, timezone) {
  return getNextWeekStartFromDate(moment(), startWeekDay, timezone)
}

export function calculateDatePickerDisplayedDate(value, timezone, userStartOfWeek, displayFormat, locale, weekNames, useNBSP) {
  let dateMoment = moment.tz(value, timezone)
  //let date = dateMoment.toDate()
  let momentNow = moment().tz(timezone)
  let currentYear = momentNow.format('YYYY')

  let thisWeekStart = getThisWeekStart(userStartOfWeek, timezone)
  let nextWeekStart = getNextWeekStartDate(userStartOfWeek, timezone)
  let next2WeekStart = getNextWeekStartDate(userStartOfWeek, timezone).add(1, 'week')
  let prevWeekStart = getThisWeekStart(userStartOfWeek, timezone).add(-1, 'week')

  let start = getWeekStartFromDate(dateMoment, userStartOfWeek, timezone)
  let end
  if (displayFormat === 'month') end = start.clone().add(4 * 7 - 1, 'days')
  else end = start.clone().add(6, 'days')

  let prefix = ''
  let restOfText = ''

  if (displayFormat === 'week' || displayFormat === 'month') {
    if (displayFormat === 'week') {
      // check if add prefix (this/prev/next week)
      if (thisWeekStart.isSameOrBefore(dateMoment) && nextWeekStart.isAfter(dateMoment)) prefix = weekNames.thisWeek
      // + start.format('MMM YYYY')
      else if (thisWeekStart.isAfter(dateMoment) && prevWeekStart.isSameOrBefore(dateMoment)) prefix = weekNames.previousWeek
      // + start.format('MMM YYYY')
      else if (nextWeekStart.isSameOrBefore(dateMoment) && next2WeekStart.isAfter(dateMoment)) prefix = weekNames.nextWeek
      else restOfText = formatRange(start, end, currentYear, dateMoment, locale)
    } else {
      restOfText = formatRange(start, end, currentYear, dateMoment, locale)
    }
  } else if (displayFormat === 'two-weeks') {
    end = getNextWeekStartFromDate(dateMoment, userStartOfWeek, timezone).add(7, 'days')
    restOfText = formatRange(start, end, currentYear, dateMoment, locale)
  } else if (displayFormat === 'day') {
    prefix = dateMoment.format('dddd') + ', '
    if (momentNow.format('YYYY') !== dateMoment.format('YYYY')) {
      restOfText = dateMoment.formatLocalized('MMM D, YYYY')
    } else {
      if (useNBSP) {
        restOfText = dateMoment.formatLocalized('MMMM\xa0DD')
      } else {
        restOfText = dateMoment.formatLocalized('MMMM D')
      }
    }
  } else {
    if (momentNow.format('YYYY') !== dateMoment.format('YYYY')) {
      restOfText = dateMoment.formatLocalized('MMM D, YYYY')
    } else {
      restOfText = dateMoment.formatLocalized('MMM D')
    }
  }

  return prefix + restOfText
}

export function calculateDisplayedRangeDate(startDate, endDate, timezone, locale) {
  let start = moment.utc(startDate).tz(timezone)
  let end = moment.utc(endDate).tz(timezone).subtract(1, 'seconds')

  let momentNow = moment().tz(timezone)
  let currentYear = momentNow.format('YYYY')

  if (start.isSame(end, 'day')) {
    if (start.format('YYYY') !== currentYear) {
      return start.formatLocalized('dddd, MMMM D')
    } else {
      return start.formatLocalized('MMM D, YYYY')
    }
  } else if (start.isSame(end, 'month')) {
    let isMonthBeforeDay = isUSAMonthDayOrder(locale)
    if (isMonthBeforeDay) {
      return start.formatLocalized('MMMM D') + ' - ' + end.formatLocalized('D')
    } else {
      return start.formatLocalized('D') + ' - ' + end.formatLocalized('D MMMM')
    }
  } else {
    if (start.format('YYYY') !== currentYear && end.format('YYYY') !== currentYear && start.format('YYYY') === end.format('YYYY')) {
      return start.formatLocalized('MMM D') + ' - ' + end.formatLocalized('MMM D, YYYY')
    } else if (start.format('YYYY') !== end.format('YYYY')) {
      return start.formatLocalized('MMM D, YYYY') + ' - ' + end.formatLocalized('MMM D, YYYY')
    } else {
      return start.formatLocalized('MMM D') + ' - ' + end.formatLocalized('MMM D')
    }
  }
}
